import { render, staticRenderFns } from "./SSTReturn.vue?vue&type=template&id=517a735c&scoped=true&"
import script from "./SSTReturn.vue?vue&type=script&lang=js&"
export * from "./SSTReturn.vue?vue&type=script&lang=js&"
import style0 from "./SSTReturn.vue?vue&type=style&index=0&id=517a735c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a735c",
  null
  
)

export default component.exports